import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';
import { UsersService, AlertService } from '../../services';

import { ConfirmComponent } from '../../modals';

export interface NotificationRecipientsModel {
	title: string;
	button: string;
    label: string;
    recipients: Array<any>;
    edit: boolean;

    notification_ended: boolean;
}

@Component({  
    selector: 'notification-recipients',
    templateUrl: './notification-recipients.html',
    styleUrls: ['./notification-recipients.scss']
})

export class NotificationRecipientsComponent extends DialogComponent<NotificationRecipientsModel, any> implements NotificationRecipientsModel, OnInit {
  	title: string;
    button: string;
  	label: string;
    recipients: Array<any>;
    edit: boolean;

    notification_ended: boolean;

    data = [];
    filterQuery = '';
    rowsOnPage = 10;
    sortBy = 'name';
    sortOrder = 'asc';

    private searchForm: FormGroup;
    private search: AbstractControl;
    private recipients_control: AbstractControl;

    private filter_term: string;
    
    private recipients_arr = [];
    private dropdownSettings: IMultiSelectSettings = {
        enableSearch: false,
        checkedStyle: 'fontawesome',
        buttonClasses: 'btn btn-default btn-block',
        dynamicTitleMaxItems: 10,
        fixedTitle: true,
        closeOnClickOutside: false,
        selectionLimit: 1,
        autoUnselect: true,
        containerClasses: 'dropdown-members'
    };

    private users_text: IMultiSelectTexts = {
        searchPlaceholder: 'Pronađi korisnika',
        searchEmptyResult: 'Nije pronađen niti jedan korisnik...',
        defaultTitle: 'Dodaj korisnika...',
    };

    private search_error_msg: boolean = false;
    private errorMsg: string = '';

  	constructor(
        dialogService: DialogService,
        private formBuilder: FormBuilder,
        private alertService: AlertService,
        private slimLoader: SlimLoadingBarService,
        private usersService: UsersService
    ) {
    	super(dialogService);
  	}

    toInt(num: string) {
        return +num;
    }

    ngOnInit() {

        this.searchForm = this.formBuilder.group({
            search: [''],
            recipients_control: []
        });

        this.search = this.searchForm.controls['search'];

        this.searchForm.controls['recipients_control'].valueChanges.subscribe((value) => {
            if (value !== null) {
                if(value.length > 0){
                    for(let i = 0; i < value.length; i++){
                        this.addUser(value[i]);
                    }
                }
            } 
        });

        if(this.recipients.length > 0){
            for(let i = 0; i < this.recipients.length; i++){
                if(this.recipients[i].recipient_id){
                    this.recipients[i].id = this.recipients[i].recipient_id;
                } else if(this.recipients[i].member_id){
                     this.recipients[i].id = this.recipients[i].member_id;
                }
                this.data.push(this.recipients[i]);
            }
        }
    }

    //Search users function
    searchUsers(term) {
        this.filter_term = term;
        
        this.usersService.getSpecificUsers(this.filter_term).subscribe(
            response => {
                if(response.users.length > 0){
                    this.search_error_msg = false;
                    for(let i = 0; i < response.users.length; i++){
                        if(response.users[i].user_profile.fullname){
                            if (response.users[i].email) {
                                response.users[i].name = response.users[i].user_profile.fullname + ' - ' + response.users[i].email;
                            } else {
                                response.users[i].name = response.users[i].user_profile.fullname;
                            }           
                        } else {
                            response.users[i].name = response.users[i].email;
                        }
                    }
                } else {
                    this.search_error_msg = true;
                }
                this.recipients_arr = response.users;
                this.slimLoader.complete();
            },
            error => {
                if(error.error_msg){
                    this.alertService.error(error.error_msg);
                    this.errorMsg = error.error_msg;
                    this.slimLoader.complete();
                }
            },
        );
    }

    // Add user function
    addUser(value) {
        this.searchForm.controls.recipients_control.reset();
        let found = this.data.some(function (el) {
            return el.id == value;
        });
        if (!found) {
            for( let i = 0; i < this.recipients_arr.length; i++){
                if(this.recipients_arr[i].id === value){
                    let activeModal = this.dialogService.addDialog(ConfirmComponent, {
                        title:'Dodaj korisnika', 
                        message:'Jeste li sigurni da želite dodati ' + this.recipients_arr[i].user_profile.fullname + ' ?',
                        button: 'Dodaj',
                    })
                    .subscribe((isConfirmed)=>{
                        if(isConfirmed) {
                            //Add user to datatable
                            this.data.push(this.recipients_arr[i]);
                            this.alertService.success("Uspješno ste dodali korisnika.");
                        }
                    });
                }
            }
        } else {
            this.alertService.error("Korisnik je već dodan!");
        }
    }

    //Delete user from datatable
    onDeleteUser(user) {
        let activeModal = this.dialogService.addDialog(ConfirmComponent, {
            title:'Izbriši člana', 
            message:'Jeste li sigurni da želite izbrisati ' + user.user_profile.fullname + ' ?',
            button: 'Izbriši',
        })
        .subscribe((isConfirmed)=>{
            if(isConfirmed) {
                if(user.id){
                    let id = user.id;
                    const toDelete = new Set([id]);

                    //Remove user from datatable
                    this.data = this.data.filter(obj => !toDelete.has(obj.id));
                    this.alertService.success("Uspješno ste izbrisali primatelja");
                    this.searchForm.controls.recipients_control.reset();
                } else if(user.recipient_id){
                    let id = user.recipient_id;
                    const toDelete = new Set([id]);

                    //Remove user from datatable
                    this.data = this.data.filter(obj => !toDelete.has(obj.recipient_id));
                    this.alertService.success("Uspješno ste izbrisali primatelja");
                    this.searchForm.controls.recipients_control.reset();
                } else {
                    let id = user.member_id;
                    const toDelete = new Set([id]);

                    //Remove user from datatable
                    this.data = this.data.filter(obj => !toDelete.has(obj.member_id));
                    this.alertService.success("Uspješno ste izbrisali primatelja");
                    this.searchForm.controls.recipients_control.reset();
                }
            }
        });
    }



  	confirm(data) {
    	// we set dialog result as true on click on confirm button, 
    	// then we can get dialog result from caller code
    	this.result = data;
    	this.close();
  	}
}



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/modals/notification-recipients/notification-recipients.component.ts